module.exports = __webpack_public_path__ + "img/icon-04.c27be152.svg";